import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

import { LOAN_QUERY_KEYS } from '@/services/loanQueryKeys'
import { deriveStageModel, stageModelService, type DerivedStageModel } from '@/services/stageModel'

/**
 * The origination stage model the server serves (`GET /loans/stages`), reduced
 * to what a screen asks of it: the labels in order and whether a stage is
 * "funded". Until the request lands (or if it is refused) it answers from the
 * typed `LOAN_STAGES` constant with `loaded: false`, so nothing flickers.
 */
export function useStageModel(): DerivedStageModel {
  const query = useQuery({
    queryKey: LOAN_QUERY_KEYS.stageModel,
    queryFn: () => stageModelService.get(),
    // A fixed server-side vocabulary that changes with a release, not a session.
    staleTime: 60 * 60 * 1000,
    retry: false,
  })
  return useMemo(() => deriveStageModel(query.data), [query.data])
}
